import { createListenerMiddleware } from '@reduxjs/toolkit';

import { UserInfoFetcher } from '../../api/fetchers/userInfo/fetcher';
import { CorePredicator } from '../CorePredicator';
import type { CoreRootState } from '../CoreStore';
import { selectShouldMergeBonusBalance } from '../slices/config/rawSelectors';

export const userInfoMiddleware = createListenerMiddleware<CoreRootState>();

const unsubscribeUserInfoOptionsListener = userInfoMiddleware.startListening({
  predicate: CorePredicator.all((state) => [selectShouldMergeBonusBalance(state) !== undefined]),
  effect: (_, { getState }) => {
    const shouldMergeBonusBalance = selectShouldMergeBonusBalance(getState());
    if (shouldMergeBonusBalance === undefined) {
      return;
    }
    UserInfoFetcher.setOptions({ totalBalance: shouldMergeBonusBalance });
    unsubscribeUserInfoOptionsListener();
  },
});
